<template>
  <v-data-table
  :headers="headers"
  :items="history"
  :search="search"
  sort-by="dateNow"
  sort-desc
  class="elevation-1 text-capitalize"
  >
  <template v-slot:top>
    <v-toolbar text color="white">
      <v-toolbar-title>History</v-toolbar-title>
      <v-divider
      class="mx-2"
      inset
      vertical
      ></v-divider>
      <v-spacer></v-spacer>
      <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      hide-details
      ></v-text-field>
    </v-toolbar>
  </template>
  <template v-slot:item.dateNow="props">
            {{ new Date(props.item.dateNow).toDateString().slice(4) }}
          </template>
  <template v-slot:item.action="{ item }">
    <!-- <v-icon medium class="blue--text d-inline mr-3" @click="loadItem(item)" > open_in_new </v-icon> -->
    <!-- <v-icon medium color="#D32F2F" class="darken-4 d-inline" @click="deleteItem(item)" > delete</v-icon> -->

    <v-btn @click="loadItem(item)" class="ml-2 mt-1" color="info" > 
      <v-icon medium class="d-inline pr-2" > open_in_new </v-icon>
      Open
    </v-btn>

    <v-btn @click="deleteItem(item)" color="#D32F2F" dark class="ml-2 mt-1">
      <v-icon medium class="darken-4 d-inline pr-1"> delete </v-icon>
    </v-btn>

  </template>
  <template v-slot:no-data>
    <div class="text-xs-center">
      Your customers history will appear here
    </div>
  </template>
</v-data-table>
</template>
<script>
import firebase from '@/helpers/firebaseConfig'
const db = firebase.firestore()
import router from '../router'

export default {
  data() {
    return{
      headers: [
      { text: 'Date', value: 'dateNow' },
      { text: 'Customer', value: 'customerName' },
      {
        text: 'Invoice',
        sortable: false,
        value: 'invoiceNum',
      },
      { text: 'Actions', value: 'action', sortable: false, align: 'end' },
      ],
      search: ''
    }
  },

  computed: {
    history(){
      return this.$store.getters.history
    }

  },

  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  created () {
      // console.log(this.history)
  },

  methods: {
    loadItem (item) {
      // console.log('item loaded', item)
      this.$store.commit('setPreview', item)
      router.push('/preview')
    },
    deleteItem (item) {
      const index = this.history.indexOf(item)
      confirm('Are you sure you want to delete this item?') && db.collection('history').doc(item.id).delete()
    },
  }
}
</script>